import type { CustomFormula } from 'src/data/customFormulas';
import {
  AI_SUGGESTION_MODE,
  type AllInstructionsData,
  GENERATION_MODE_TYPE,
  type GenerationModeType,
} from 'src/data/generation';
import { filterVisibleDDTemplates } from 'src/data/utils';
import type { ID } from 'src/lib/collection';

import type { GenerationTool } from './const';
import { getToolGenerationModes } from './toolGenerationModes';
import { getToolMixtureSubGenerationTools } from './toolProps';

export interface SubGenerationToolProps {
  isCustomFormulasVisible?: boolean;
  selectedModeId?: ID;
  selectedModeType?: GenerationModeType;
  visibleDDTemplates?: string[];
  errors?: Record<string, string>;
  generationTool?: GenerationTool;
  subGenerationTool?: GenerationTool;
  structureInstructionsData?: AllInstructionsData;
}

type MultiPromptSubGenerationToolProps = Record<string, SubGenerationToolProps>;

export const initMultiPromptSubGenerationToolProps = (
  generationTool: GenerationTool,
  customFormulas?: CustomFormula[]
): MultiPromptSubGenerationToolProps => {
  const subGenerationTools = getToolMixtureSubGenerationTools(generationTool);
  if (!subGenerationTools) {
    return {};
  }

  const result: MultiPromptSubGenerationToolProps = {};
  subGenerationTools.forEach((subGenerationTool) => {
    const availableTemplates = getToolGenerationModes(subGenerationTool);
    const visibleTemplates = filterVisibleDDTemplates(availableTemplates);
    const customFormula = customFormulas?.find(
      (customFormula) => customFormula.generationTool === subGenerationTool
    );
    const selectedModeId = customFormula?.id || visibleTemplates[0];
    const selectedModeType = customFormula
      ? GENERATION_MODE_TYPE.customFormula
      : GENERATION_MODE_TYPE.common;
    result[subGenerationTool] = {
      isCustomFormulasVisible: availableTemplates.includes(AI_SUGGESTION_MODE.customFormula),
      selectedModeId,
      selectedModeType,
      visibleDDTemplates: visibleTemplates,
      errors: {},
      generationTool: subGenerationTool,
      subGenerationTool,
    };
  });
  return result;
};
